/**
 * GarageGuard — route-level guard for the Garage module.
 *
 * When garageEnabled is false, redirects to /dashboard.
 * When garageEnabled is true (or absent), renders children normally.
 *
 * Used to protect the /garage route from direct URL access
 * when the team has garage disabled.
 */

import { Navigate } from 'react-router-dom';
import { useGarageEnabled } from '@/hooks/useGarageEnabled';

interface GarageGuardProps {
  children: React.ReactNode;
}

export function GarageGuard({ children }: GarageGuardProps) {
  const garageEnabled = useGarageEnabled();

  if (!garageEnabled) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
